import { useTranslation } from "react-i18next";
import "./style.css";
import ActionBtn from "@/components/ActionBtn";
import SideCol from "../../../shared/SideCol/SideCol";
import { SideSection } from "../../../shared/SideCol/SideSection";
import { useContext } from "react";
import { AMAcceptQuotation } from "@/api/endpoints/AccountManager";
import { errorToast, successToast } from "@/utils/toasters";
import { DomainContext } from "@/context/DomainContext";

const QuotationSummary = ({ selectedHospital, quotationData }) => {
  const { t } = useTranslation();
    const { setLoading } = useContext(DomainContext)


    console.log("quotationData", quotationData);
   

  const handleAMAcceptQuotation = async () => {
    setLoading((l) => l + 1)
    await AMAcceptQuotation(quotationData?.orderId).then((res) => {
      console.log("res", res);
      successToast("accepted successfully");
    }).catch((err) => {
      errorToast(err?.response?.data?.message);
    }).finally(() => {
      setLoading((l) => l - 1)
    })
  };


  return (
    <SideCol
      className="qs-sidebar"
      title={t("quotation-summary")}
      icon="solar:shield-check-outline"
    >
      <SideSection
        title={t("base-medical-fee")}
        value={`${selectedHospital?.price || 0} $`}
      />
      <div className="qs-divider" />
      <SideSection
        title={t("total-journey-price")}
        value={`${selectedHospital?.price || 0} $`}
      />
     

      <ActionBtn
        onApply={handleAMAcceptQuotation}
        title={t("finalize-notify")}
        icon="tabler:send"
        className="w-100 rounded mb-3"
        isDisabled={quotationData?.isVerified}
      />

      
    </SideCol>
  );
};

export default QuotationSummary;
